import useExternalScript from './useExternalScript';

const useTypeformScript = () => {
  useExternalScript('//embed.typeform.com/next/embed.js');
};

export default useTypeformScript;
